import projectSetting from './projectSetting';
export default projectSetting;
